// App.js - Versión actualizada con rutas SEO simples
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from './components/ScrollToTop';
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { PostDetail } from "./pages/PostDetail";
import { CategoryPage } from "./pages/CategoryPage";
import { MembersPage } from "./pages/MembersPage";
import { AboutPage } from "./pages/AboutPage";
import { ContactPage } from "./pages/ContactPage";
import { SearchPage } from "./pages/SearchPage";
import { SEOHead } from "./components/SEOHead";

// Componentes SEO (agregar estas importaciones)
import { SEODashboard } from "./components/SEODashboard";
import { SEOAdmin } from "./components/SEOAdmin";

import "./App.css";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          {/* Meta tags por defecto de la aplicación */}
          <SEOHead
            title=""
            description="Red de medios de comunicación de Arauca"
            keywords="noticias, arauca, colombia, medios, comunicación"
            type="website"
          />

          <Header />

          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/post/:slug" element={<PostDetail />} />
              <Route path="/categoria/:slug" element={<CategoryPage />} />
              <Route path="/noticias" element={<CategoryPage />} />
              <Route path="/medios" element={<MembersPage />} />
              <Route path="/nosotros" element={<AboutPage />} />
              <Route path="/contacto" element={<ContactPage />} />
              <Route path="/buscar" element={<SearchPage />} />
              
              {/* Rutas SEO - Accesibles directamente */}
              <Route path="/seo" element={<SEODashboard />} />
              <Route path="/seo-admin" element={<SEOAdmin />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;